import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "styles/index.css";
import "styles/globals.css";
import AppWrapper from "app";
import reportWebVitals from "app/reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <AppWrapper />
  </StrictMode>,
);
reportWebVitals();
